// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import ChildRoutes from './routes';
import THEntityLayout from '@Organisms/THEntityLayout/THEntityLayout';
import { useGetAccessibleRoutes } from '@Helpers/getAccessibleRoutes';

import './AccountDetails.scss';

const AccountDetails = (): ReactElement => {
    const accessibleRoutes = useGetAccessibleRoutes(ChildRoutes);
    return <THEntityLayout routes={accessibleRoutes} actions={[]} title="Account settings" />;
};

export const Route: RouteType = {
    path: RouteBuilder.compute('account.default'),
    breadcrumb: {
        label: 'breadcrumb.global.account',
    },
    content: <AccountDetails />,
    space: ['admin', 'user'],
};
